import React, { useEffect, useState, useCallback } from "react";
import { fetch_match_invites, post_get_evaluated_invite } from "../../Api";

const MyLobbyInvites = ({ onClose }) => {
    const [invites, setInvites] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedInvite, setSelectedInvite] = useState(null);
    const [hoveredId, setHoveredId] = useState(null);
    const [errorMessage, setErrorMessage] = React.useState(null);

    // Fetch invites on mount
    useEffect(() => {
        const loadInvites = async () => {
            try {
                const data = await fetch_match_invites();
                setInvites(data);
            } catch (err) {
                setError("Failed to load invites");
            } finally {
                setLoading(false);
            }
        };
        loadInvites();
    }, []);

    const onKeyDown = useCallback(
        (e) => {
            if (e.key === "Escape") setSelectedInvite(null);
        },
        [setSelectedInvite]
    );

    useEffect(() => {
        if (selectedInvite) {
            window.addEventListener("keydown", onKeyDown);
        } else {
            window.removeEventListener("keydown", onKeyDown);
        }
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [selectedInvite, onKeyDown]);

    if (loading) return <p>Loading invites...</p>;
    if (error) return <p>{error}</p>;
    // if (invites.length === 0) return <p>No invites found.</p>;

    const handleAcceptMatch = async (invite) => {
        setErrorMessage(null); // reset on new attempt

        try {
            await post_get_evaluated_invite(invite.id);
            setSelectedInvite(null);
            onClose(); // use the same onClose as the Close button

        } catch (error) {
            console.error("Failed to accept invite:", error);
            setErrorMessage(error.message || "An unexpected error occurred.");
        }
    };

    // New ErrorModal component
    const ErrorModal = ({ message, onClose }) => (
        <div style={modalOverlayStyle} onClick={onClose} role="alertdialog" aria-modal="true">
            <div style={{ ...modalContentStyle, maxWidth: 400 }} onClick={e => e.stopPropagation()}>
                <h3 style={{ color: "red" }}>Error</h3>
                <p>{message}</p>
                <button
                    onClick={onClose}
                    style={{
                        padding: "8px 16px",
                        cursor: "pointer",
                    //    backgroundColor: "#dc3545",
                     //   color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        marginTop: 16,
                    }}
                    aria-label="Close error message"
                >
                    Close
                </button>
            </div>
        </div>
    );

    return (
        <div
            style={{
                padding: 16,
            //    backgroundColor: "#ff9b54",
            //    border: "4px solid #e68a3f",      // slightly darker for depth
            //    borderTopColor: "#ff9b54",        // top lighter to simulate lift
             //   borderLeftColor: "#ff9b54",
             //   borderBottomColor: "#e68a3f",     // bottom darker for shadow
              //  borderRightColor: "#e68a3f",
                borderRadius: 6,
            }}
        >            {!selectedInvite ? (
            <>
                {loading && <p>Loading invites...</p>}
                {error && <p>{error}</p>}

                {!loading && !error && invites.length === 0 && (
                    <>
                        <p>No invites found.</p>
                        <button onClick={onClose}>Close</button>
                    </>
                )}

                {invites.length > 0 && (
                    <>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr>
                                    <th style={thStyle}>Invited By</th>
                                    <th style={thStyle}>Sport Name</th>
                                    <th style={thStyle}>Team Size</th>
                                    <th style={thStyle}>Game Type</th>
                                    <th style={thStyle}>Created At</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invites.map((invite) => (
                                    <tr
                                        key={invite.id}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setSelectedInvite(invite)}
                                        onMouseEnter={() => setHoveredId(invite.id)}
                                        onMouseLeave={() => setHoveredId(null)}
                                    >
                                        <td style={tdStyle}>{invite.friend_name}</td>
                                        <td style={tdStyle}>{invite.sport_name}</td>
                                        <td style={tdStyle}>{invite.player}</td>
                                        <td style={tdStyle}>{invite.game_type}</td>
                                        <td style={tdStyle}>
                                            {new Date(invite.created_at).toLocaleString()}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <button
                            onClick={onClose}
                            style={{
                                marginTop: 16,
                                padding: "8px 16px",
                                cursor: "pointer",
                               // backgroundColor: "#dc3545",
                             //   color: "#fff",
                                border: "none",
                                borderRadius: 4,
                            }}
                        >
                            Close
                        </button>
                    </>
                )}
            </>
        ) : (
            <Modal
                onClose={() => {
                    setSelectedInvite(null);
                    setErrorMessage(null);
                }}
            >
                <h2
                    style={{
                      //  color: "#2e2d2dff",
                        padding: "8px 16px",
                     //   border: "4px solid #2e2d2dff",

                     //   borderBottomColor: "#2a2a2a", // darker shadow at bottom
                      //  borderRightColor: "#2a2a2a",
                        borderRadius: 6,
                        boxShadow: "2px 2px 5px rgba(0,0,0,0.3)",
                        display: "inline-block",
                    }}
                >
                    Invite Details
                </h2>
                <InviteDetails invite={selectedInvite} />
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                        marginTop: 16,
                    }}
                >
                    {/* Message box */}
                    <div
                        style={{
                          //  backgroundColor: "#fff3cd",
                         //   border: "1px solid #ffeeba",
                         //   color: "#856404",
                            padding: "12px 16px",
                            borderRadius: 4,
                            fontSize: 14,
                        }}
                    >
                        By accepting this, you agree that any match lobby you created or any queue you are in will be deleted.
                    </div>

                    {/* Buttons */}
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                        <button
                            onClick={() => setSelectedInvite(null)}
                            style={{
                                padding: "8px 16px",
                                cursor: "pointer",
                              //  backgroundColor: "#007bff",
                            //    color: "#fff",
                                border: "none",
                                borderRadius: 4,
                                flex: "1 1 auto",
                                minWidth: 120,
                            }}
                            aria-label="Back to invites list"
                        >
                            ← Back
                        </button>

                        <button
                            onClick={() => handleAcceptMatch(selectedInvite)}
                            style={{
                                padding: "8px 16px",
                                cursor: "pointer",
                              //  backgroundColor: "#28a745",
                              //  color: "#fff",
                                border: "none",
                                borderRadius: 4,
                                flex: "1 1 auto",
                                minWidth: 120,
                            }}
                            aria-label="Accept match"
                        >
                            Accept Match
                        </button>
                    </div>
                </div>


            </Modal>
        )}

            {errorMessage && (
                <ErrorModal message={errorMessage} onClose={() => setErrorMessage(null)} />
            )}
        </div>
    );



};

const InviteDetails = ({ invite }) => (
    <div style={{ color: "#302f2fff" }}>
        <p>
            <strong>Game Type:</strong> {invite.game_type}
        </p>
        <p>
            <strong>Player:</strong> {invite.player}
        </p>
        <p>
            <strong>Location:</strong> {invite.location}
        </p>
        <p>
            <strong>Age Range:</strong> {invite.min_age} - {invite.max_age}
        </p>
        <p>
            <strong>Average Height:</strong> {invite.avg_height} ft
        </p>
        <p>
            <strong>Average Weight:</strong> {invite.avg_weight} kg
        </p>

        <p style={{ display: 'none' }}>
            <strong>Coordinates:</strong> {invite.latitude}, {invite.longitude}
        </p>

        <p>
            <strong>Max Distance (km):</strong> {invite.maximum_distance}
        </p>
        <p>
            <strong>Gender Preference:</strong> {invite.gender_preference}
        </p>

        <p>
            <strong>Sport Display Name:</strong> {invite.sport_display_name}
        </p>
        <p>
            <strong>Tier:</strong> {invite.tier_name}
        </p>
    </div>
);

const Modal = ({ children, onClose }) => (
    <div style={modalOverlayStyle} onClick={onClose}>
        <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
            {children}
        </div>
    </div>
);

const thStyle = {
    borderBottom: "2px solid #333",
    padding: "8px",
    textAlign: "left",
};

const tdStyle = {
    padding: "8px",
};

const modalOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
   // backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
};

const modalContentStyle = {
     background: "#fbfbfb",
    borderRadius: 6,
    padding: 24,
    width: "90%",
    maxWidth: 600,
    maxHeight: "80vh",
    overflowY: "auto",
 //   boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
};

export default MyLobbyInvites;
